import React from "react";
import styles from "./cards.module.css";

const EMPTY_VALUE = "--";
const DEFAULT_COLOR = "#3158df";

const formatValue = (value) => {
  if (value === null || value === undefined || value === "") return EMPTY_VALUE;
  return typeof value === "number" ? value.toLocaleString() : value;
};

const Card = ({ card, loading }) => {
  const title = card.title ?? card.heading;
  const color = card.color ?? card.accentColor ?? DEFAULT_COLOR;
  const onClick = card.onClick ?? card.handleCardClick;
  const isLoading = loading || card.loading;
  const isInteractive = Boolean(onClick) && !isLoading;

  const displayValue = formatValue(card.value ?? card.count);
  const isEmpty = displayValue === EMPTY_VALUE;
  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onClick();
    }
  };

  const interactiveProps = isInteractive
    ? { role: "button", tabIndex: 0, onClick, onKeyDown: handleKeyDown }
    : {};

  return (
    <div
      className={`${styles.card} ${isInteractive ? styles.clickable : ""}`}
      style={{ "--accent": color }}
      {...interactiveProps}
    >
      <p className={styles.title}>{title}</p>

      <div className={styles.body}>
        {isLoading ? (
          <div className={styles.skeleton} role="status" aria-label="Loading" />
        ) : (
          <h2 className={`${styles.value} ${isEmpty ? styles.empty : ""}`}>
            {displayValue}
          </h2>
        )}
      </div>
    </div>
  );
};

const Cards = ({ cards = [], loading = false }) => (
  <div className={styles.grid} aria-busy={loading}>
    {cards.map((card, index) => (
      <Card
        key={card.id ?? card.title ?? card.heading ?? index}
        card={card}
        loading={loading}
      />
    ))}
  </div>
);

export default Cards;